
import { useMemo } from 'react';

/**
 * Hook to get and manage the admin name
 */
export const useAdminName = () => {
  // Get admin name from localStorage - memoize to prevent re-renders
  const adminName = useMemo(() => localStorage.getItem('adminName') || 'Admin', []);
  
  return { adminName };
};
